import { format, startOfMonth, subMonths } from "date-fns";
import { CompareDropdownType, CompareRangeType } from "./DateDropdownContext";
import { FirstWeekDay } from "../../types";
import { DateOptions } from "../../src/utils/constants";
import { getPreviousYearDates } from "./utils/getPreviousYearDates";
import { getPreviousPeriodDates } from "./utils/getPreviousPeriodDates";

export const localStorageDateRangeKey = "dateRange";
export const localStorageCompareRangeKey = "compareRange";

export const getInitialDateRange = () => {
  if (typeof window === "undefined")
    return {
      from: format(startOfMonth(new Date()), "yyyy-MM-dd"),
      to: format(new Date(), "yyyy-MM-dd"),
    };

  const savedDateRange = localStorage.getItem(localStorageDateRangeKey);

  if (savedDateRange) {
    return JSON.parse(savedDateRange);
  }

  return {
    from: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    to: format(new Date(), "yyyy-MM-dd"),
  };
};

export const getInitialCompareRange = () => {
  if (typeof window === "undefined")
    return {
      prevStartDate: format(startOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd"),
      prevEndDate: format(subMonths(new Date(), 1), "yyyy-MM-dd"),
    };

  const savedCompareRange = localStorage.getItem(localStorageCompareRangeKey);

  if (savedCompareRange) {
    return JSON.parse(savedCompareRange);
  }

  return {
    prevStartDate: format(startOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd"),
    prevEndDate: format(subMonths(new Date(), 1), "yyyy-MM-dd"),
  };
};

export const getCompareRange = (
  type: CompareDropdownType,
  from: Date,
  to: Date,
  index: DateOptions,
  firstWeekDay: FirstWeekDay,
): CompareRangeType | null => {
  switch (type) {
    case "previousYear": {
      const { prevFrom, prevTo } = getPreviousYearDates(from, to, index);
      return {
        prevStartDate: format(prevFrom, "yyyy-MM-dd"),
        prevEndDate: format(prevTo, "yyyy-MM-dd"),
      };
    }
    case "previousPeriod": {
      const { prevFrom, prevTo } = getPreviousPeriodDates(from, to, index, firstWeekDay);
      return {
        prevStartDate: format(prevFrom, "yyyy-MM-dd"),
        prevEndDate: format(prevTo, "yyyy-MM-dd"),
      };
    }
    default:
      return null;
  }
};
